import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContentLoaderComponent } from './content-loader/content-loader.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TableLoaderComponent } from './table-loader/table-loader.component';
import { SearchLoaderComponent } from './search-loader/search-loader.component';
import { CardLoaderComponent } from './card-loader/card-loader.component';
import { MatCardModule } from '@angular/material/card';
import { ImgLoaderComponent } from './img-loader/img-loader.component';
import { BilluComponent } from './billu/billu.component';
import { CouponComponent } from './coupon/coupon.component';
import { MatButtonModule } from '@angular/material/button';
import { GearLoaderComponent } from './gear-loader/gear-loader.component';
import { ImgZoomComponent } from './img-zoom/img-zoom.component';
import { GlobalLoaderComponent } from './global-loader/global-loader.component';



@NgModule({
  declarations: [
    ContentLoaderComponent,
    TableLoaderComponent,
    SearchLoaderComponent,
    CardLoaderComponent,
    ImgLoaderComponent,
    BilluComponent,
    CouponComponent,
    GearLoaderComponent,
    ImgZoomComponent,
    GlobalLoaderComponent,
  ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatCardModule,
    MatButtonModule
  ],
    exports: [
        ContentLoaderComponent,
        TableLoaderComponent,
        SearchLoaderComponent,
        CardLoaderComponent,
        ImgLoaderComponent,
        BilluComponent,
        CouponComponent,
        GearLoaderComponent,
        ImgZoomComponent,
        GlobalLoaderComponent
    ]
})
export class LoaderModule { }
